<template>
  <div>
    <div v-if="!isLogged">
      <div
        class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
        id="page-login"
        v-bind:style="{ 'background-image': 'url(' + imagenFondo + ') !important' }"
      >
        <img
          v-if="ingresoLogo"
          :src="ingresoLogo.imagen"
          id="logo"
          v-bind:style="logoStyle"
          alt="logo"
        />
        <b-card class="text-center" v-if="provider === 'esign7'">
          <h5 class="message my-5">
            No cierre la página mientras está en el proceso de enrolamiento
          </h5>
          <VerifyIdentityExternal />
        </b-card>

        <b-card v-if="provider === 'signapi'" style="min-width: 450px;">
          <h5 class="mb-4 text-center">Verificación de identidad</h5>
          <p class="text-muted text-center mb-4">
            Complete los datos para iniciar la verificación de identidad.
          </p>
          <b-overlay :show="loading">
            <form data-vv-scope="signapi">
              <div class="row">
                <div class="col-12 mt-2">
                  <vs-input
                    autocomplete="off"
                    class="w-100 cursor-default"
                    label="RUT"
                    name="rut"
                    :value="jwtData.iut"
                    readonly
                  />
                </div>
                <div class="col-12 mt-2">
                  <vs-input
                    autocomplete="off"
                    class="w-100 cursor-default"
                    label="Nombre"
                    name="name"
                    :value="jwtData.name"
                    readonly
                  />
                </div>
                <div class="col-12 mt-2">
                  <vs-input
                    autocomplete="off"
                    class="w-100 cursor-default"
                    label="Correo"
                    name="email"
                    :value="jwtData.email"
                    readonly
                  />
                </div>
                <div class="col-12 mt-2">
                  <vs-input
                    autocomplete="off"
                    class="w-100"
                    label="Número de serie del documento (carnet)"
                    maxlength="20"
                    name="serialNumber"
                    v-model="serialNumber"
                    placeholder="Ej: 531417340"
                    v-validate="'required'"
                    :danger="errors.has('signapi.serialNumber')"
                    :danger-text="errors.first('signapi.serialNumber')"
                  />
                </div>
                <div class="col-12 mt-2">
                  <vs-input
                    autocomplete="off"
                    class="w-100"
                    label="Comuna de residencia"
                    maxlength="100"
                    name="commune"
                    v-model="commune"
                    placeholder="Ej: Santiago"
                    v-validate="'required'"
                    :danger="errors.has('signapi.commune')"
                    :danger-text="errors.first('signapi.commune')"
                  />
                </div>
              </div>
              <div class="text-center mt-4">
                <b-button
                  variant="primary"
                  @click="verifyWithSignApi"
                  :disabled="loading"
                >
                  Verificar identidad
                </b-button>
              </div>
            </form>
          </b-overlay>
        </b-card>
      </div>
    </div>
  </div>
</template>
<script>
import ActivateEnrollment
  from '@/febos/global/usuario/components/sign/advanced/eSign/components/ActivateEnrollment';
import VerifyIdentityExternal
  from '@/febos/global/usuario/components/sign/advanced/eSign/components/VerifyIdentityExternal';
import ButtonClaveUnica from '@/components/ButtonClaveUnica';
import PersonalizacionMixin from '@/febos/global/empresas/mixins/PersonalizacionMixin';
import { decodeJwt } from '@/febos/global/utils/jwt';

export default {
  mixins: [PersonalizacionMixin],
  components: {
    ButtonClaveUnica,
    ActivateEnrollment,
    VerifyIdentityExternal
  },
  props: {
    user: { type: Object },
    signConfiguration: { type: Object },
    isLogged: { type: Boolean },
    isAuthorized: { type: Boolean }
  },
  data() {
    return {
      provider: 'esign7',
      jwtData: {},
      serialNumber: '',
      commune: '',
      loading: false,
    };
  },
  computed: {
    token() {
      const { token } = this.$route.params;
      return token;
    }
  },
  methods: {
    async verifyWithSignApi() {
      const isValid = await this.$validator.validateAll('signapi');
      if (!isValid) return;

      this.loading = true;
      const env = process.env.VUE_APP_AMBIENTE;
      const callback = this.fixedEncodeURIComponent(
        `https://${this.getBasePath()}/${this.getAmbit()}/firma-externo/validacion/${this.token}`
      );
      const url = `https://api.febos.cl/${env}/v2/aprobaciones/externas/firma/enrrolamiento?`
        + `urlCallback=${callback}?status=ok&idProceso=`
        + `&urlCallbackError=${callback}?status=error&idProceso=`
        + `&Authorization=${this.token}`
        + `&serialNumber=${encodeURIComponent(this.serialNumber)}`
        + `&commune=${encodeURIComponent(this.commune)}`;
      window.location.href = url;
    },
    fixedEncodeURIComponent(str) {
      return encodeURIComponent(str)
        .replace(/[!'()]/g, escape)
        .replace(/\*/g, '%2A');
    },
    getAmbit() {
      const options = /cloud|proveedores|cliente/i;
      const defaultAmbit = 'cloud';
      try {
        const parts = window.location.href
          .replace('https://', '')
          .replace('http://', '')
          .split('/');
        if (parts[0].includes('localhost')) {
          return parts[2].match(options) ? parts[2] : defaultAmbit;
        }
        return parts[3].match(options) ? parts[3] : defaultAmbit;
      } catch (e) {
        return defaultAmbit;
      }
    },
    getBasePath() {
      const resultados = window.location.href
        .replace('https://', '')
        .replace('http://', '')
        .split('/');
      return resultados != null && resultados.length >= 0 ? resultados[0] : '';
    }
  },
  created() {
    this.jwtData = decodeJwt(this.token);
    this.provider = this.jwtData.provider || 'esign7';
  }
};
</script>

<style scoped>
.message-info {
  color: white;
  width: 500px;
  font-weight: normal;
  background: #ea7037;
  border-radius: 10px 10px 10px 10px;
  padding: 10px;
}
</style>
